import {
  Paper,
  Typography,
  Grid,
  ToggleButtonGroup,
  ToggleButton,
  FormControl,
  MenuItem,
  Checkbox,
  ListItemText,
  Select
} from '@mui/material';
import { Analytics, Edit } from '@mui/icons-material';

import { RTFOISIPDataTable } from './RTFOISIPDataTable';
import { RTFOISIPChart } from './RTFOISIPChart';
import { useEffect, useState } from 'react';
import RTFOISIPEdit from './RTFOISIPEdit';
import { useSelector } from 'react-redux';

import { selectUser } from '../../reducers/userSlice';
import { useSocket } from '../../context/useSocket';

export const RTFOISIP = ({ theme, darkMode, currentRTFO, currentWellName = 'All' }) => {
  const user = useSelector(selectUser);
  const { socket } = useSocket();

  const currentStage = currentRTFO?.stageData?.[currentRTFO?.currentStageName];
  const historicStages =
    [
      ...((currentWellName === 'All'
        ? currentRTFO?.stages
        : currentRTFO?.stages?.filter(s => s.includes(currentWellName))) || [])
    ]?.reverse() || [];
  // const historicStages = [...(currentWellName === 'All' ? currentRTFO?.stages : currentRTFO?.stages?.filter(s => s.includes(currentWellName)))]?.filter(s => s !== currentStage?.name)?.reverse() || [];

  const [selectedStages, setSelectedStages] = useState(() => {
    const currentStageIndex = historicStages?.indexOf(currentStage?.name);
    let _selectedStages = [];

    let idx = historicStages?.length - 1;

    while (idx < currentStageIndex) {
      _selectedStages.push(historicStages[idx]);
      idx++;
    }

    _selectedStages = [..._selectedStages, ...(historicStages || []).slice(currentStageIndex, currentStageIndex + 6)];
    return _selectedStages;
  });

  const [isEditMode, setIsEditMode] = useState(false);


  useEffect(() => {
    console.log('Updating selected stages...');

    const allStages = [
      ...((currentWellName === 'All'
        ? currentRTFO?.stages
        : currentRTFO?.stages?.filter(s => s.includes(currentWellName))) || [])
    ].reverse();
    const currentStageIndex = allStages?.indexOf(currentStage?.name);
    let _selectedStages = [];

    let idx = currentStageIndex - 5;

    while (idx < currentStageIndex && idx >= 0) {
      _selectedStages.push(allStages[idx]);
      idx++;
    }

    _selectedStages = [
      ...Array.from(new Set([..._selectedStages, ...(allStages || []).slice(currentStageIndex, currentStageIndex + 6), ...selectedStages]))
    ];
    // ]?.filter(s => currentRTFO?.stageData?.[s]?.coldboreData);

    setSelectedStages(_selectedStages);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStage?.name, currentWellName]);

  return (
    <Paper
      elevation={0}
      sx={{ display: 'flex', height: 'calc(100%)', boxShadow: 1 }}
      style={{
        padding: '20px',
        margin: '10px 20px',
        flexDirection: 'column',
        justifyContent: 'center',
        backgroundColor: theme?.palette?.elevationOne?.[darkMode ? 'dark' : 'light']
      }}
    >
      <Typography variant="h6" style={{ marginBottom: '20px' }}>
        ISIP Analysis
      </Typography>

      <Grid
        container
        style={{
          height: '900px',
          width: '100%',
          display: 'flex'
        }}
      >
        <Grid item style={{ height: '900px', width: '50%' }}>
          <RTFOISIPDataTable currentRTFO={currentRTFO} darkMode={darkMode} />
        </Grid>

        <Grid
          item
          style={{
            height: '600px',
            width: '50%',
            display: 'flex',
            position: 'relative',
            marginTop: 10
          }}
        >
          <div style={{ position: 'absolute', top: 0, left: 10 }}>
            <Typography variant="caption" style={{ marginRight: 10 }}>
              Filter:
            </Typography>
            <FormControl>
              <Select
                value={selectedStages}
                label="Stages"
                title="Select Stages"
                multiple
                onChange={handleStagesChange}
                size="small"
                variant="standard"
                style={{ width: 150, height: 28, zIndex: 69, fontSize: '12px', marginRight: 20 }}
                renderValue={selected => selected.join(', ')}
              >
                <MenuItem value="Select All">
                  <Checkbox checked={true} />
                  <ListItemText primary="Select All" />
                </MenuItem>
                <MenuItem value="Deselect All">
                  <Checkbox checked={false} />
                  <ListItemText primary="Deselect All" />
                </MenuItem>
                {historicStages?.map((name, i) => (
                  <MenuItem key={`${name}-${i}`} value={name} disabled={name === currentStage?.name}>
                    <Checkbox checked={selectedStages.indexOf(name) > -1} />
                    <ListItemText primary={name} style={{ color: currentRTFO?.stageData?.[name]?.coldboreData ? '#333' : 'lightgrey' }} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <ToggleButtonGroup
            value={isEditMode}
            size="small"
            style={{ height: 24, position: 'absolute', top: 0, left: 220, zIndex: 666 }}
            onChange={(e, val) => setIsEditMode(val)}
            exclusive
          >
            <ToggleButton value={true} size="small" title="Edit ISIP" color={darkMode ? '' : 'primary'}>
              <Edit style={{ fontSize: '16px' }} />
            </ToggleButton>
          </ToggleButtonGroup>

          {(currentStage && currentStage?.metrics?.isip > 0 )|| selectedStages?.length > 1 ? (
            <div style={{ width: '100%', height: 600, marginTop: 40 }}>
              <RTFOISIPChart
                gridView={true}
                showSpikeLines={true}
                wellName={currentWellName}
                selectedStages={selectedStages}
                showLegend={true}
              />
            </div>
          ) : currentStage && !currentStage?.metrics?.isip > 0 ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%'
              }}
            >
              <Analytics style={{ fontSize: '72px', color: 'grey' }} />
              <Typography variant="body2" style={{ color: 'grey' }}>
                ISIP not available
              </Typography>
            </div>
          ) : (
            <div>
              <Typography variant="body2" style={{ color: 'grey' }}>
                No data selected
              </Typography>
            </div>
          )}
        </Grid>
      </Grid>

      {isEditMode && <RTFOISIPEdit setIsEditMode={setIsEditMode} />}
    </Paper>
  );

  function handleStagesChange(event) {
    const {
      target: { value }
    } = event;

    if (typeof value !== 'string' && value?.indexOf('Deselect All') !== -1) {
      console.log('Deselecting all stages...');
      setSelectedStages([currentStage?.name]);
    } else if (typeof value !== 'string' && value?.indexOf('Select All') !== -1) {
      setSelectedStages(historicStages?.filter(s => currentRTFO?.stageData?.[s]?.coldboreData));
    } else {
      const newSelectedStages = typeof value === 'string' ? value.split(',') : value;
      const requestedStages = newSelectedStages?.filter(s => !currentRTFO?.stageData?.[s]?.coldboreData);

      if (requestedStages?.length > 0 && socket?.readyState === 1) {
        console.log(`Requesting low-resolution data for ${requestedStages?.length} stages`);
        socket?.send(JSON.stringify({
          messageType: 'getResampledStagesData',
          stageNames: requestedStages,
          userEmail: user?.value?.email
        }));
      };
      setSelectedStages(newSelectedStages);
    }
  }
};
